// GAuthModal.js
import React, { useEffect, useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import config from "../../config";
import { getCsrfToken } from "../../auth/csrf";

const GAuthModal = ({ visible, onClose, onSuccess, userData }) => {
	const [pin, setPin] = useState('');
	const [loading, setLoading] = useState(false);

	const handleVerify = async () => {
		if (pin.length !== 6) {
			message.error('Please enter a 6-digit PIN');
			return;
		}

		setLoading(true);

		try {
			const csrf = await getCsrfToken();

			const API_BASE = config.API_BASE;

            const url = `${API_BASE}/2fa/validate2FA`;
            const res = await fetch(url, {
                method: 'POST', credentials: 'include',
                headers: { 'X-CSRF-TOKEN': csrf, 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: Number(pin) }),
            });

			if (!res.ok) throw new Error('Verification failed');

			const result = await res.json();

			if (result === true) {
				message.success('Verification successful');
				onSuccess();
			} else {
				message.error('Incorrect PIN, please try again');
			}
		} catch (err) {
			message.error('Something went wrong');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (pin.length === 6) {
			handleVerify();
		} //eslint-disable-next-line
	}, [pin]);

	return (
		<Modal
			title="Two-Factor Authentication"
			open={visible}
			onCancel={onClose}
			footer={null}
			centered
		>
			<p style={{ marginBottom: '10px', fontWeight: 500, color: '#000' }}>
				Please enter your 6-digit Google Authenticator PIN
			</p>
			<Input.OTP length={6} value={pin} onChange={(value) => setPin(value)} />
			<Button
				type="primary"
				onClick={handleVerify}
				loading={loading}
				style={{ marginTop: 16, width: '100%' }}
			>
				Verify
			</Button>
		</Modal>
	);
};

export default GAuthModal;
